import {put, takeEvery, call} from 'redux-saga/effects';
import {GET_SYNC_STATUS} from '../constants';
import {getSyncStatusRequest, getSyncStatusSuccess, getSyncStatusFailure} from '../actions';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

import {GetSyncStatusRequest, GetSyncStatusSuccess, GetSyncStatusFailure} from '../typedef';

type IActions = GetSyncStatusRequest | GetSyncStatusSuccess | GetSyncStatusFailure;

function* getSyncStatusData(action: IActions) {
    try {
        yield put(getSyncStatusRequest());

        const dataSyncStatus = yield call(Api.fetch, {
            endpoint: 'synchronize/status',
            method: ApiMethods.GET
        });

        yield put(getSyncStatusSuccess(dataSyncStatus.responseData));
    } catch (e) {
        yield put(getSyncStatusFailure());
    }
}

function* getSyncStatusSaga() {
    yield takeEvery(GET_SYNC_STATUS, getSyncStatusData);
}

export {getSyncStatusSaga};

